import React from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  Paper,
  Divider,
  Breadcrumbs,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const ShippingPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 4 }}>
        <Link component={RouterLink} to="/" color="inherit">
          Home
        </Link>
        <Typography color="text.primary">Shipping Policy</Typography>
      </Breadcrumbs>
      
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Shipping Policy
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Effective Date: March 7, 2025
        </Typography>
      </Box>
      
      {/* Content */}
      <Paper 
        elevation={0} 
        className="glass-container"
        sx={{ 
          p: 4,
          borderRadius: 4
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          1. Nature of Product
        </Typography>
        <Typography variant="body1" paragraph>
          SharkPanzer provides only digital services. No physical shipping is involved.
        </Typography>
        <Typography variant="body1" paragraph>
          All Knowledge Capsules and related content are delivered digitally through the SharkPanzer platform.
        </Typography>
        
        <Divider sx={{ my: 4 }} />
        
        <Typography variant="h5" component="h2" gutterBottom>
          2. Delivery Timeline
        </Typography>
        <Typography variant="body1" paragraph>
          Delivery is instant after the Knowledge Capsule is processed.
        </Typography>
        <Typography variant="body1" paragraph>
          Users can access their digital content directly on the SharkPanzer platform.
        </Typography>
        
        <Divider sx={{ my: 4 }} />
        
        <Typography variant="h5" component="h2" gutterBottom>
          3. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          For any issues related to delivery:
        </Typography>
        <Typography variant="body1" paragraph>
          📧 Email: support@unwiringtech.com
        </Typography>
        <Typography variant="body1" paragraph>
          🕒 Support Hours: Live Human Support 24x7 on the website or message us on Telegram @unwiringlife
        </Typography>
      </Paper>
    </Container>
  );
};

export default ShippingPage;
